import * as Constants from '../constants';

const initialState = {
  data: {
    profile: {},
  },
  error: {
    profile: {},
  },
  selectedVariant: {},
};

export default function reducer(state = initialState, action = {}) {
  const { payload } = action;
  switch (action.type) {
    case Constants.GET_LOYALTY_DATA:
      return {
        ...state,
        data: {
          ...state.data,
        },
        error: {
          ...state.error,
        },
      };

    case Constants.GET_LOYALTY_DATA_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          profile: action.data.data,
        },
      };

    case Constants.GET_LOYALTY_DATA_FAILURE:
      return {
        ...state,
        error: {
          ...state.error,
          profile: action.data.error,
        },
      };

    case Constants.RESET_LOYALTY_DATA:
      return initialState;
    case Constants.SELECT_VARIANT:
      return {
        ...state,
        selectedVariant: {
          ...payload,
          programId: payload.programID || payload.programId,
          variantId: payload.id
        },
      };
    case Constants.RESET_SELECTED_VARIANT_DATA:
      return {
        ...state,
        selectedVariant: {},
      };
    default:
      return state;
  }
}
